import * as ReactQuery from 'react-query';
import { InferMutationOptions, Services } from 'services';
import { Store } from 'store';
import { useIntl } from 'react-intl';
import { createExternalReferralAPI } from './api';

const CREATE_EXTERNAL_REFERRAL_KEY = '@referrals/create-external-referral';

export function useCreateExternalReferral(
  options?: InferMutationOptions<typeof createExternalReferralAPI>
) {
  const queryClient = ReactQuery.useQueryClient();
  const { showNotification } = Store.useNotifications();
  const intl = useIntl();

  const { mutate, isLoading, isError } = ReactQuery.useMutation(
    CREATE_EXTERNAL_REFERRAL_KEY,
    createExternalReferralAPI,
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(
          Services.Referrals.KEYS.SEARCH_REFERRALS_KEY
        );

        showNotification({
          variant: 'success',
          description: intl.formatMessage({
            id: 'is.add_external_referral.success_notification',
            defaultMessage: 'Patient added successfully',
          }),
        });

        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
      onError: (error, variables, context) => {
        showNotification({
          variant: 'error',
          description: intl.formatMessage(
            error.isTranslationFromServer
              ? {
                  id:
                    error.translationKey ||
                    'server.errors.generic_error_message',
                  defaultMessage: error.message,
                }
              : {
                  id: 'server.errors.create_external_referral_error',
                  defaultMessage:
                    'Unfortunately, something failed when adding the patient. Please, try again.',
                }
          ),
        });

        if (options?.onError) {
          options.onError(error, variables, context);
        }
      },
    }
  );

  return {
    createExternalReferral: mutate,
    isLoading,
    isError,
  };
}
